/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_PaymentsInputs */

const en_settings_nav_payments = /** @type {(inputs: Settings_Nav_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Settings_Nav_PaymentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_nav_payments = /** @type {((inputs?: Settings_Nav_PaymentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_PaymentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_nav_payments(inputs)
});
export { settings_nav_payments as "settings.nav.payments" }